export type Palette = {
  key: string
  name: string
  primary: string
  info: string
  success: string
  warning: string
  error: string
  neutralBg?: string
  neutralText?: string
}

export const PRESET_PALETTES: Palette[] = [
  {
    key: "dark",
    name: "Dark",
    primary: "#ef476f",
    info: "#3e92cc",
    success: "#4d8b31",
    warning: "#ffbc42",
    error: "#ae2e1e",
    neutralBg: "#141414",
    neutralText: "#f8f7ff",
  },
  {
    key: "light",
    name: "Light",
    primary: "#ef476f",
    info: "#3e92cc",
    success: "#4d8b31",
    warning: "#ffbc42",
    error: "#ae2e1e",
    neutralBg: "#f8f7ff",
    neutralText: "#141414",
  },
  {
    key: "renaissance",
    name: "Renaissance",
    primary: "#8d0801",
    info: "#708d81",
    success: "#99e2b4",
    warning: "#c18c5d",
    error: "#bf0603",
    neutralBg: "#001427",
    neutralText: "#fffcf2",
  },
  {
    key: "earthy",
    name: "Earthy Tones",
    primary: "#333d29",
    info: "#b6ad90",
    success: "#c2c5aa",
    warning: "#7f4f24",
    error: "#582f0e",
    neutralBg: "#656d4a",
    neutralText: "#F2F3F4",
  },
  {
    key: "rustic",
    name: "Rustic",
    primary: "#eb5e28",
    info: "#073b4c",
    success: "#4f772d",
    warning: "#403d39",
    error: "#800e13",
    neutralBg: "#252422",
    neutralText: "#fffcf2",
  },
  {
    key: "watermelon",
    name: "Watermelon",
    primary: "#ef476f",
    info: "#118ab2",
    success: "#06d6a0",
    warning: "#ffd166",
    error: "#ef476f",
    neutralBg: "#073b4c",
    neutralText: "#fffcf2",
  },
  {
    key: "moon",
    name: "Moon",
    primary: "#393d3f",
    info: "#62929e",
    success: "#546a7b",
    warning: "#c6c5b9",
    error: "#c44536",
    neutralBg: "#001427",
    neutralText: "#fdfdff",
  },
  {
    key: "eggplant",
    name: "Eggplant",
    primary: "#5e548e",
    info: "#08bdbd",
    success: "#8cb369",
    warning: "#ff9914",
    error: "#f21b3f",
    neutralBg: "#1b2021",
    neutralText: "#fdfdff",
  },
  {
    key: "twilight",
    name: "Twilight",
    primary: "#ffc300",
    info: "#003566",
    success: "#004b23",
    warning: "#ff9f1c",
    error: "#001d3d",
    neutralBg: "#000814",
    neutralText: "#fdfdff",
  },
]
